// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IAddAnalyticsOrderRequest,
  TAddAnalyticsOrderModel,
  IMappers,
  TAddAnalyticsOrderResponse,
  IAddAnalyticsOrderResponse,
  IAddAnalyticsOrderResponseError,
} from './types';

export const defaultConfig: TAddAnalyticsOrderModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'valuation-b2b',
  pathApi: '/v2/add-analytics-order/',
  requestType: 'json',
} as TAddAnalyticsOrderModel;

export function createAddAnalyticsOrderModel(parameters: IAddAnalyticsOrderRequest): TAddAnalyticsOrderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddAnalyticsOrderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IAddAnalyticsOrderRequest;
}

export async function fetchAddAnalyticsOrder<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddAnalyticsOrderOptions<TResponse200, TResponse400>): Promise<
  TAddAnalyticsOrderResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createAddAnalyticsOrderModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddAnalyticsOrderResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IAddAnalyticsOrderResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TAddAnalyticsOrderResponse;
}
